import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filterbybank',
  templateUrl: './filterbybank.component.html',
  styleUrls: ['./filterbybank.component.css']
})
export class FilterbybankComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
